import React from 'react';
import type { FC } from 'react';

import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

import { StyledToggleButton, StyledToggleContainer } from './RCX.styled';

type ToggleButtonProps = {
    width: number;
    isCollapse: boolean;
    onClick: () => void;
};

export const ToggleButton: FC<ToggleButtonProps> = ({ width, isCollapse, onClick }) => {
    return (
        <StyledToggleContainer width={width}>
            <StyledToggleButton onClick={onClick} aria-label={isCollapse ? 'Open' : 'Close'}>
                {isCollapse ? <ArrowRightIcon /> : <ArrowLeftIcon />}
            </StyledToggleButton>
        </StyledToggleContainer>
    );
};
